import { useChannelHealthCheckChannelHealthPostMutation } from '@shared/api';
import { useNotify } from '@shared/hooks/use-notify';
import { useState } from 'react';

export const useHealthCheckChannel = () => {
  const [healthCheckChannelMutation, { isLoading }] =
    useChannelHealthCheckChannelHealthPostMutation();
  const [loadingChannelId, setLoadingChannelId] = useState<number | null>(null);

  const notify = useNotify();

  const healthCheckChannel = async (channelId: number) => {
    setLoadingChannelId(channelId);
    try {
      const response = await healthCheckChannelMutation({ channelId }).unwrap();

      notify({
        message: response.message,
        type: response.is_live ? 'success' : 'error',
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingChannelId(null);
    }
  };

  return {
    healthCheckChannel,
    isLoading,
    loadingChannelId,
  };
};
